import { Files, Search, ArrowLeft } from 'lucide-react';
import clsx from 'clsx';

interface ActivityBarProps {
  activePanel: 'explorer' | 'none';
  onPanelChange: (panel: 'explorer' | 'none') => void;
  onBack?: () => void;
}

export default function ActivityBar({
  activePanel,
  onPanelChange,
  onBack,
}: ActivityBarProps) {
  return (
    <div className="flex flex-col items-center bg-[#181818] border-r border-dark-border">
      <button
        onClick={onBack}
        className="p-3 text-gray-500 hover:text-white transition-colors"
        title="Back to project selection"
      >
        <ArrowLeft className="h-5 w-5" />
      </button>

      <div className="w-full h-px bg-dark-border" />

      <button
        onClick={() =>
          onPanelChange(activePanel === 'explorer' ? 'none' : 'explorer')
        }
        className={clsx(
          'relative p-3 transition-colors',
          activePanel === 'explorer'
            ? 'text-white'
            : 'text-gray-500 hover:text-gray-300',
        )}
        title="Explorer"
      >
        <Files className="h-5 w-5" />
        {activePanel === 'explorer' && (
          <div className="absolute left-0 top-1/2 -translate-y-1/2 w-0.5 h-6 bg-white rounded-r" />
        )}
      </button>

      <button
        className="p-3 text-gray-500 hover:text-gray-300 transition-colors opacity-50 cursor-default"
        title="Search (coming soon)"
      >
        <Search className="h-5 w-5" />
      </button>
    </div>
  );
}
